const initCopyLink = () => {
  const copyButtons = document.querySelectorAll('.copy-link');

  copyButtons.forEach((button) => {
      button.addEventListener('click', () => {
          const url = button.getAttribute('data-url');
          if (url) {
              navigator.clipboard.writeText(url)
                  .then(() => {
                      showTooltip(button, 'Copied!');
                  })
                  .catch((error) => {
                      console.error('Failed to copy text:', error);
                      showTooltip(button, 'Error copying');
                  });
          } else {
              console.error('No URL found to copy!');
              showTooltip(button, 'No URL');
          }
      });
  });

  const showTooltip = (button, message) => {
      let tooltip = button.querySelector('.tooltip');
      if (!tooltip) {
          tooltip = document.createElement('span');
          tooltip.className = 'tooltip';
          button.appendChild(tooltip);
      }

      tooltip.textContent = message;
      tooltip.classList.add('visible');

      setTimeout(() => {
          tooltip.classList.remove('visible');
      }, 2000);
  };
};

export { initCopyLink };
